import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { response } from '../common/interface';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(
    private http : HttpClient
  ) { }

  getInvoices(tableName, barristerId, solicitorId, clientId, caseId, status, fundingTypeId, limit, orderBy){
    let params : HttpParams = new HttpParams().set('tableName', tableName).set('barristerId', barristerId).set("solicitorId", solicitorId).set("clientId", clientId).set("caseId", caseId).set("status", status).set("fundingTypeId", fundingTypeId).set("limit", limit).set('orderBy', orderBy);
    return this.http.get<response>(environment.url + "invoices", {params : params});
  }

  getInvoiceStatement(tableName, caseId, fundingTypeId, status, orderBy){
    let params : HttpParams = new HttpParams().set('tableName', tableName).set('caseId', caseId).set("fundingTypeId", fundingTypeId).set("status", status).set('orderBy', orderBy);
    return this.http.get<response>(environment.url + "invoices/statements", {params : params});
  }

  getInvoice(tableName, id, caseId){
    let params : HttpParams = new HttpParams().set("tableName", tableName).set("id", id).set('caseId', caseId);
    return this.http.get<response>(environment.url + "invoice", {params : params});
  }

  saveInvoice(data){
    return this.http.post<response>(environment.url + "invoices", data);
  }

  uploadInvoice(data){
    return this.http.post<response>(environment.url + "invoices/upload", data);
  }

  removeInvoice(id, password){
    let params : HttpParams = new HttpParams().set('id', id).set('password', password);
    return this.http.delete<response>(environment.url + "invoices", {params : params});
  }

  savePayment(data){
    return this.http.post<response>(environment.url + "invoices/payment", data);
  }
  
  removePayment(id, tableName, password){
    let params : HttpParams = new HttpParams().set('id', id).set('tableName', tableName).set('password', password);
    return this.http.delete<response>(environment.url + "invoices/payment", {params : params});
  }

}
